/**
 *  @class
 *  @function VideoControls
 */
if (!customElements.get('video-controls')) {
  class VideoControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video = this.parentElement.querySelector('video');
      this.sound_toggle = this.querySelector('.video-controls--sound');
      this.play_toggle = this.querySelector('.video-controls--play-pause');

      this.setInitialState();
      this.setEventListeners();
    }

    setInitialState() {
      if (this.video.paused) {
        this.play_toggle?.classList.add('paused');
      } else {
        this.play_toggle?.classList.remove('paused');
      }

      if (this.video.muted) {
        this.sound_toggle?.classList.add('muted');
      } else {
        this.sound_toggle?.classList.remove('muted');
      }
    }

    setEventListeners() {
      this.play_toggle?.addEventListener('click', this.playPause.bind(this));
      this.sound_toggle?.addEventListener('click', this.muteUnmute.bind(this));
    }

    playPause(e) {
      if (this.video.paused) {
        this.video.play();
        this.play_toggle?.classList.remove('paused');
      } else {
        this.video.pause();
        this.play_toggle?.classList.add('paused');
      }
      e.stopPropagation();
    }

    muteUnmute(e) {
      this.video.muted = !this.video.muted;
      this.sound_toggle?.classList.toggle('muted', this.video.muted);
      e.stopPropagation();
    }
  }

  customElements.define('video-controls', VideoControls);
}

/* ==========================
   Carousel + video integration
   ========================== */
document.addEventListener('DOMContentLoaded', function() {
  var carousels = document.querySelectorAll('.shoppable-video-reels--carousel');

  carousels.forEach(function(carouselEl) {
    var flkty = new Flickity(carouselEl, {
      cellAlign: 'center',
      contain: true,
      draggable: true,
      pageDots: true,
      wrapAround: true // ✅ allow looping
    });

    var slides = carouselEl.querySelectorAll('.carousel__slide');

    // Helper: pause all videos except optional one
    function pauseAllVideos(exceptVideo) {
      slides.forEach(function(slide) {
        var v = slide.querySelector('video');
        if (v && v !== exceptVideo) {
          v.pause();
          slide.querySelector('.video-controls--play-pause')?.classList.add('paused');
        }
      });
    }

    // On page load: only play the centered slide
    var activeSlide = slides[flkty.selectedIndex];
    var activeVideo = activeSlide.querySelector('video');
    pauseAllVideos(activeVideo);
    if (activeVideo) {
      activeVideo.play().catch(() => {});
      activeSlide.querySelector('.video-controls--play-pause')?.classList.remove('paused');
    }

    // Flickity change → pause others, play active
    flkty.on('change', function(index) {
      var currentSlide = slides[index];
      var currentVideo = currentSlide.querySelector('video');
      pauseAllVideos(currentVideo);
      if (currentVideo) {
        currentVideo.play().catch(() => {});
        currentSlide.querySelector('.video-controls--play-pause')?.classList.remove('paused');
      }
    });

    // Click a slide → center it, pause others, play clicked video
    slides.forEach(function(slide, index) {
      slide.addEventListener('click', function(e) {
        if (e.target.closest('.video-controls')) return;

        // Center clicked slide
        flkty.select(index);

        // Small delay ensures Flickity updates selectedIndex
        setTimeout(function() {
          var activeSlide = slides[flkty.selectedIndex];
          var activeVideo = activeSlide.querySelector('video');

          // Pause all other videos
          pauseAllVideos(activeVideo);

          // Play the clicked/centered video
          if (activeVideo) {
            activeVideo.play().catch(() => {});
            activeSlide.querySelector('.video-controls--play-pause')?.classList.remove('paused');
          }
        }, 50);
      });
    });
  });
});